<p-button
  text
  size="small"
  severity="secondary"
  icon="pi pi-eye"
  [disabled]="!hasData()"
  [pTooltip]="buttonTooltip()"
  tooltipPosition="right"
  (click)="isDialogVisible.set(true)">
</p-button>

<p-dialog
  [visible]="isDialogVisible()"
  (visibleChange)="isDialogVisible.set($event)"
  [appendTo]="'body'"
  [baseZIndex]="11000"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [breakpoints]="{ '1300px': '92vw', '980px': '96vw' }"
  [style]="{ width: 'min(94vw, 1080px)', maxHeight: '86vh' }"
  [contentStyle]="{ overflow: 'hidden', height: 'clamp(440px, 58vh, 640px)' }"
  [header]="title()">
  @if (hasData()) {
    <section class="flex h-full min-h-0 flex-col">
      <div class="mb-3 flex flex-wrap items-center justify-start">
        <p-selectbutton
          [options]="previewModeOptions"
          [allowEmpty]="false"
          [ngModel]="viewMode()"
          (ngModelChange)="viewMode.set($event)">
        </p-selectbutton>
      </div>

      <div class="min-h-0 flex-1 overflow-auto rounded-lg border border-gray-500/70 bg-gray-950/50 p-3">
        @if (viewMode() === 'structured') {
          <div class="space-y-4">
            <section>
              <h4 class="mb-2 text-sm font-semibold">Structured Fields</h4>
              @if (scalarSections().length > 0) {
                <div class="space-y-3">
                  @for (section of scalarSections(); track section.key) {
                    <section class="rounded border border-gray-700/80 bg-gray-900/35">
                      <div class="border-b border-gray-700/80 px-2 py-1">
                        <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-200">{{ formatPropertyLabel(section.key) }}</h4>
                      </div>
                      <table class="w-full text-xs">
                        <tbody>
                          @for (entry of section.entries; track entry.key) {
                            <tr class="border-b border-gray-700/80 align-top">
                              <th class="w-[40%] p-2 text-left font-medium text-gray-300">{{ entry.key }}</th>
                              <td class="p-2 break-all text-gray-100">{{ entry.value }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </section>
                  }
                </div>
              } @else {
                <p class="rounded border border-gray-700/80 bg-gray-900/60 px-3 py-2 text-xs text-gray-300">No scalar fields.</p>
              }
            </section>

            @for (collection of collectionTables(); track collection.key) {
              <section class="rounded border border-gray-700/80 bg-gray-900/35">
                <div class="flex items-center justify-between gap-3 border-b border-gray-700/80 px-2 py-1">
                  <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-200">{{ formatPropertyLabel(collection.key) }}</h4>
                  <span class="text-xs text-gray-300">{{ collection.itemCount }} item(s)</span>
                </div>

                @if (collection.itemCount > 0) {
                  <div class="overflow-auto">
                    <table class="w-full text-xs">
                      <thead>
                        <tr class="border-b border-gray-700/80 bg-gray-900/60">
                          @for (column of collection.columns; track column) {
                            <th class="p-2 text-left font-semibold text-gray-200">{{ column }}</th>
                          }
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of collection.rows; track $index) {
                          <tr class="border-b border-gray-800/80 align-top">
                            @for (column of collection.columns; track column) {
                              <td class="p-2 break-all text-gray-100">{{ row[column] }}</td>
                            }
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                } @else {
                  <p class="px-3 py-2 text-xs text-gray-300">No items in this collection.</p>
                }
              </section>
            }
          </div>
        } @else {
          <pre class="h-full overflow-auto rounded border border-gray-700/80 bg-gray-900/60 p-3 text-xs text-gray-100">{{ jsonPreview() }}</pre>
        }
      </div>
    </section>
  }
</p-dialog>
